import { U as head, V as bind_props, W as attr, X as ensure_array_like, Y as attributes, Z as attr_class, _ as stringify, $ as store_get, a0 as unsubscribe_stores, a1 as spread_props, a2 as attr_style, a3 as clsx } from "../../chunks/index.js";
import { n as noop, g as getContext, f as fallback, e as escape_html } from "../../chunks/context.js";
import "@sveltejs/kit/internal";
import { w as writable } from "../../chunks/exports.js";
import "../../chunks/utils.js";
import "@sveltejs/kit/internal/server";
import "../../chunks/state.svelte.js";
import { d as decorate, B as Button } from "../../chunks/button.js";
import "clsx";
import { z } from "zod";
import { o as onDestroy, h as html } from "../../chunks/index-server.js";
const now = () => Date.now();
const raf = {
  // don't access requestAnimationFrame eagerly outside method
  // this allows basic testing of user code without JSDOM
  // bunder will eval and remove ternary when the user's app is built
  tick: (
    /** @param {any} _ */
    (_) => noop()
  ),
  now: () => now(),
  tasks: /* @__PURE__ */ new Set()
};
function loop(callback) {
  let task;
  if (raf.tasks.size === 0) ;
  return {
    promise: new Promise((fulfill) => {
      raf.tasks.add(task = { c: callback, f: fulfill });
    }),
    abort() {
      raf.tasks.delete(task);
    }
  };
}
const favicon = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='107'%20height='128'%20viewBox='0%200%20107%20128'%3e%3ctitle%3esvelte-logo%3c/title%3e%3cpath%20d='M94.157%2022.819c-10.4-14.885-30.94-19.297-45.792-9.835L22.282%2029.608A29.92%2029.92%200%200%200%208.764%2049.65a31.5%2031.5%200%200%200%203.108%2020.231%2030%2030%200%200%200-4.477%2011.183%2031.9%2031.9%200%200%200%205.448%2024.116c10.402%2014.887%2030.942%2019.297%2045.791%209.835l26.083-16.624A29.92%2029.92%200%200%200%2098.235%2078.35a31.53%2031.53%200%200%200-3.105-20.232%2030%2030%200%200%200%204.474-11.182%2031.88%2031.88%200%200%200-5.447-24.116'%20style='fill:%23ff3e00'/%3e%3cpath%20d='M45.817%20106.582a20.72%2020.72%200%200%201-22.237-8.243%2019.17%2019.17%200%200%201-3.277-14.503%2018%2018%200%200%201%20.624-2.435l.49-1.498%201.337.981a33.6%2033.6%200%200%200%2010.203%205.098l.97.294-.09.968a5.85%205.85%200%200%200%201.052%203.878%206.24%206.24%200%200%200%206.695%202.485%205.8%205.8%200%200%200%201.603-.704L69.27%2076.28a5.43%205.43%200%200%200%202.45-3.631%205.8%205.8%200%200%200-.987-4.371%206.24%206.24%200%200%200-6.698-2.487%205.7%205.7%200%200%200-1.6.704l-9.953%206.345a19%2019%200%200%201-5.296%202.326%2020.72%2020.72%200%200%201-22.237-8.243%2019.17%2019.17%200%200%201-3.277-14.502%2017.99%2017.99%200%200%201%208.13-12.052l26.081-16.623a19%2019%200%200%201%205.3-2.329%2020.72%2020.72%200%200%201%2022.237%208.243%2019.17%2019.17%200%200%201%203.277%2014.503%2018%2018%200%200%201-.624%202.435l-.49%201.498-1.337-.98a33.6%2033.6%200%200%200-10.203-5.1l-.97-.294.09-.968a5.86%205.86%200%200%200-1.052-3.878%206.24%206.24%200%200%200-6.696-2.485%205.8%205.8%200%200%200-1.602.704L37.73%2051.72a5.42%205.42%200%200%200-2.449%203.63%205.79%205.79%200%200%200%20.986%204.372%206.24%206.24%200%200%200%206.698%202.486%205.8%205.8%200%200%200%201.602-.704l9.952-6.342a19%2019%200%200%201%205.295-2.328%2020.72%2020.72%200%200%201%2022.237%208.242%2019.17%2019.17%200%200%201%203.277%2014.503%2018%2018%200%200%201-8.13%2012.053l-26.081%2016.622a19%2019%200%200%201-5.3%202.328'%20style='fill:%23fff'/%3e%3c/svg%3e";
const getStores = () => {
  const stores$1 = getContext("__svelte__");
  return {
    /** @type {typeof page} */
    page: {
      subscribe: stores$1.page.subscribe
    },
    /** @type {typeof navigating} */
    navigating: {
      subscribe: stores$1.navigating.subscribe
    },
    /** @type {typeof updated} */
    updated: stores$1.updated
  };
};
const page = {
  subscribe(fn) {
    const store = getStores().page;
    return store.subscribe(fn);
  }
};
function Seo($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    let title = fallback($$props["title"], "");
    let description = fallback($$props["description"], "");
    let canonical = fallback($$props["canonical"], void 0);
    let keywords = fallback($$props["keywords"], void 0);
    let author = fallback($$props["author"], void 0);
    let robots = fallback($$props["robots"], void 0);
    let lang = fallback($$props["lang"], void 0);
    let twitter = fallback(
      $$props["twitter"],
      () => ({
        card: void 0,
        site: void 0,
        title,
        description: void 0,
        image: { url: void 0, alt: void 0, width: 0, height: 0 }
      }),
      true
    );
    let og = fallback(
      $$props["og"],
      () => ({
        title,
        description: void 0,
        url: void 0,
        type: void 0,
        site_name: void 0,
        locale: void 0,
        image: {
          url: void 0,
          alt: void 0,
          width: 0,
          height: 0,
          type: void 0
        }
      }),
      true
    );
    let geo = fallback(
      $$props["geo"],
      () => ({
        region: void 0,
        position: void 0,
        placename: void 0,
        icbm: void 0
      }),
      true
    );
    let additionalRobotsProps = fallback($$props["additionalRobotsProps"], void 0);
    let languageAlternates = fallback($$props["languageAlternates"], void 0);
    let additionalMetaTags = fallback($$props["additionalMetaTags"], void 0);
    let additionalLinkTags = fallback($$props["additionalLinkTags"], void 0);
    if (additionalRobotsProps) {
      const {
        nosnippet,
        maxSnippet,
        maxImagePreview,
        maxVideoPreview,
        noarchive,
        noimageindex,
        notranslate,
        unavailableAfter
      } = additionalRobotsProps;
    }
    if (!robots && additionalRobotsProps) {
      console.warn("additionalRobotsProps cannot be used when robots is set to false");
    }
    head("1p1hxl5", $$renderer2, ($$renderer3) => {
      $$renderer3.title(($$renderer4) => {
        $$renderer4.push(`<title>${escape_html(decorate(title))}</title>`);
      });
      if (description) {
        $$renderer3.push("<!--[-->");
        $$renderer3.push(`<meta name="description"${attr("content", description)}/>`);
      } else {
        $$renderer3.push("<!--[!-->");
      }
      $$renderer3.push(`<!--]--> `);
      if (canonical) {
        $$renderer3.push("<!--[-->");
        $$renderer3.push(`<link rel="canonical"${attr("href", canonical)}/>`);
      } else {
        $$renderer3.push("<!--[!-->");
      }
      $$renderer3.push(`<!--]--> `);
      if (keywords && keywords?.length) {
        $$renderer3.push("<!--[-->");
        $$renderer3.push(`<meta name="keywords"${attr("content", keywords)}/>`);
      } else {
        $$renderer3.push("<!--[!-->");
      }
      $$renderer3.push(`<!--]--> `);
      if (lang) {
        $$renderer3.push("<!--[-->");
        $$renderer3.push(`<meta name="language"${attr("content", lang)}/>`);
      } else {
        $$renderer3.push("<!--[!-->");
      }
      $$renderer3.push(`<!--]--> `);
      if (author) {
        $$renderer3.push("<!--[-->");
        $$renderer3.push(`<meta name="author"${attr("content", author)}/>`);
      } else {
        $$renderer3.push("<!--[!-->");
      }
      $$renderer3.push(`<!--]--> `);
      if (languageAlternates && languageAlternates.length > 0) {
        $$renderer3.push("<!--[-->");
        $$renderer3.push(`<!--[-->`);
        const each_array = ensure_array_like(languageAlternates);
        for (let $$index = 0, $$length = each_array.length; $$index < $$length; $$index++) {
          let languageAlternate = each_array[$$index];
          $$renderer3.push(`<link rel="alternate"${attr("hreflang", languageAlternate.hrefLang)}${attr("href", languageAlternate.href)}/>`);
        }
        $$renderer3.push(`<!--]-->`);
      } else {
        $$renderer3.push("<!--[!-->");
      }
      $$renderer3.push(`<!--]--> `);
      if (geo) {
        $$renderer3.push("<!--[-->");
        if (geo.region) {
          $$renderer3.push("<!--[-->");
          $$renderer3.push(`<meta name="geo.region"${attr("content", geo.region)}/>`);
        } else {
          $$renderer3.push("<!--[!-->");
        }
        $$renderer3.push(`<!--]--> `);
        if (geo.position) {
          $$renderer3.push("<!--[-->");
          $$renderer3.push(`<meta name="geo.position"${attr("content", geo.position)}/>`);
        } else {
          $$renderer3.push("<!--[!-->");
        }
        $$renderer3.push(`<!--]--> `);
        if (geo.placename) {
          $$renderer3.push("<!--[-->");
          $$renderer3.push(`<meta name="geo.position"${attr("content", geo.placename)}/>`);
        } else {
          $$renderer3.push("<!--[!-->");
        }
        $$renderer3.push(`<!--]--> `);
        if (geo.icbm) {
          $$renderer3.push("<!--[-->");
          $$renderer3.push(`<meta name="ICBM" content="geo.icbm"/>`);
        } else {
          $$renderer3.push("<!--[!-->");
        }
        $$renderer3.push(`<!--]-->`);
      } else {
        $$renderer3.push("<!--[!-->");
      }
      $$renderer3.push(`<!--]--> `);
      if (twitter) {
        $$renderer3.push("<!--[-->");
        if (twitter.card) {
          $$renderer3.push("<!--[-->");
          $$renderer3.push(`<meta name="twitter:card"${attr("content", twitter.card)}/>`);
        } else {
          $$renderer3.push("<!--[!-->");
        }
        $$renderer3.push(`<!--]--> `);
        if (twitter.site) {
          $$renderer3.push("<!--[-->");
          $$renderer3.push(`<meta name="twitter:site"${attr("content", twitter.site)}/>`);
        } else {
          $$renderer3.push("<!--[!-->");
        }
        $$renderer3.push(`<!--]--> `);
        if (twitter.title) {
          $$renderer3.push("<!--[-->");
          $$renderer3.push(`<meta name="twitter:title"${attr("content", decorate(twitter.title))}/>`);
        } else {
          $$renderer3.push("<!--[!-->");
        }
        $$renderer3.push(`<!--]--> `);
        if (twitter.description) {
          $$renderer3.push("<!--[-->");
          $$renderer3.push(`<meta name="twitter:description"${attr("content", twitter.description)}/>`);
        } else {
          $$renderer3.push("<!--[!-->");
        }
        $$renderer3.push(`<!--]--> `);
        if (twitter.image) {
          $$renderer3.push("<!--[-->");
          $$renderer3.push(`<meta name="twitter:image"${attr("content", twitter.image)}/>`);
        } else {
          $$renderer3.push("<!--[!-->");
        }
        $$renderer3.push(`<!--]-->`);
      } else {
        $$renderer3.push("<!--[!-->");
      }
      $$renderer3.push(`<!--]--> `);
      if (og) {
        $$renderer3.push("<!--[-->");
        if (og.url || canonical) {
          $$renderer3.push("<!--[-->");
          $$renderer3.push(`<meta property="og:url"${attr("content", og.url || canonical)}/>`);
        } else {
          $$renderer3.push("<!--[!-->");
        }
        $$renderer3.push(`<!--]--> `);
        if (og.type) {
          $$renderer3.push("<!--[-->");
          $$renderer3.push(`<meta property="og:type"${attr("content", og.type.toLowerCase())}/> `);
          if (og.type.toLowerCase() === "profile" && og.profile) {
            $$renderer3.push("<!--[-->");
            if (og.profile.firstName) {
              $$renderer3.push("<!--[-->");
              $$renderer3.push(`<meta property="profile:first_name"${attr("content", og.profile.firstName)}/>`);
            } else {
              $$renderer3.push("<!--[!-->");
            }
            $$renderer3.push(`<!--]--> `);
            if (og.profile.lastName) {
              $$renderer3.push("<!--[-->");
              $$renderer3.push(`<meta property="profile:last_name"${attr("content", og.profile.lastName)}/>`);
            } else {
              $$renderer3.push("<!--[!-->");
            }
            $$renderer3.push(`<!--]--> `);
            if (og.profile.username) {
              $$renderer3.push("<!--[-->");
              $$renderer3.push(`<meta property="profile:username"${attr("content", og.profile.username)}/>`);
            } else {
              $$renderer3.push("<!--[!-->");
            }
            $$renderer3.push(`<!--]--> `);
            if (og.profile.gender) {
              $$renderer3.push("<!--[-->");
              $$renderer3.push(`<meta property="profile:gender"${attr("content", og.profile.gender)}/>`);
            } else {
              $$renderer3.push("<!--[!-->");
            }
            $$renderer3.push(`<!--]-->`);
          } else {
            $$renderer3.push("<!--[!-->");
            if (og.type.toLowerCase() === "book" && og.book) {
              $$renderer3.push("<!--[-->");
              if (og.book.authors && og.book.authors.length) {
                $$renderer3.push("<!--[-->");
                $$renderer3.push(`<!--[-->`);
                const each_array_1 = ensure_array_like(og.book.authors);
                for (let $$index_1 = 0, $$length = each_array_1.length; $$index_1 < $$length; $$index_1++) {
                  let author2 = each_array_1[$$index_1];
                  $$renderer3.push(`<meta property="book:author"${attr("content", author2)}/>`);
                }
                $$renderer3.push(`<!--]-->`);
              } else {
                $$renderer3.push("<!--[!-->");
              }
              $$renderer3.push(`<!--]--> `);
              if (og.book.isbn) {
                $$renderer3.push("<!--[-->");
                $$renderer3.push(`<meta property="book:isbn"${attr("content", og.book.isbn)}/>`);
              } else {
                $$renderer3.push("<!--[!-->");
              }
              $$renderer3.push(`<!--]--> `);
              if (og.book.releaseDate) {
                $$renderer3.push("<!--[-->");
                $$renderer3.push(`<meta property="book:release_date"${attr("content", og.book.releaseDate)}/>`);
              } else {
                $$renderer3.push("<!--[!-->");
              }
              $$renderer3.push(`<!--]--> `);
              if (og.book.tags && og.book.tags.length) {
                $$renderer3.push("<!--[-->");
                $$renderer3.push(`<!--[-->`);
                const each_array_2 = ensure_array_like(og.book.tags);
                for (let $$index_2 = 0, $$length = each_array_2.length; $$index_2 < $$length; $$index_2++) {
                  let tag = each_array_2[$$index_2];
                  $$renderer3.push(`<meta property="book:tag"${attr("content", tag)}/>`);
                }
                $$renderer3.push(`<!--]-->`);
              } else {
                $$renderer3.push("<!--[!-->");
              }
              $$renderer3.push(`<!--]-->`);
            } else {
              $$renderer3.push("<!--[!-->");
              if (og.type.toLowerCase() === "article" && og.article) {
                $$renderer3.push("<!--[-->");
                if (og.article.publishedTime) {
                  $$renderer3.push("<!--[-->");
                  $$renderer3.push(`<meta property="article:published_time"${attr("content", og.article.publishedTime)}/>`);
                } else {
                  $$renderer3.push("<!--[!-->");
                }
                $$renderer3.push(`<!--]--> `);
                if (og.article.modifiedTime) {
                  $$renderer3.push("<!--[-->");
                  $$renderer3.push(`<meta property="article:modified_time"${attr("content", og.article.modifiedTime)}/>`);
                } else {
                  $$renderer3.push("<!--[!-->");
                }
                $$renderer3.push(`<!--]--> `);
                if (og.article.expirationTime) {
                  $$renderer3.push("<!--[-->");
                  $$renderer3.push(`<meta property="article:expiration_time"${attr("content", og.article.expirationTime)}/>`);
                } else {
                  $$renderer3.push("<!--[!-->");
                }
                $$renderer3.push(`<!--]--> `);
                if (og.article.authors && og.article.authors.length) {
                  $$renderer3.push("<!--[-->");
                  $$renderer3.push(`<!--[-->`);
                  const each_array_3 = ensure_array_like(og.article.authors);
                  for (let $$index_3 = 0, $$length = each_array_3.length; $$index_3 < $$length; $$index_3++) {
                    let author2 = each_array_3[$$index_3];
                    $$renderer3.push(`<meta property="article:author"${attr("content", author2)}/>`);
                  }
                  $$renderer3.push(`<!--]-->`);
                } else {
                  $$renderer3.push("<!--[!-->");
                }
                $$renderer3.push(`<!--]--> `);
                if (og.article.section) {
                  $$renderer3.push("<!--[-->");
                  $$renderer3.push(`<meta property="article:section"${attr("content", og.article.section)}/>`);
                } else {
                  $$renderer3.push("<!--[!-->");
                }
                $$renderer3.push(`<!--]--> `);
                if (og.article.tags && og.article.tags.length) {
                  $$renderer3.push("<!--[-->");
                  $$renderer3.push(`<!--[-->`);
                  const each_array_4 = ensure_array_like(og.article.tags);
                  for (let $$index_4 = 0, $$length = each_array_4.length; $$index_4 < $$length; $$index_4++) {
                    let tag = each_array_4[$$index_4];
                    $$renderer3.push(`<meta property="article:tag"${attr("content", tag)}/>`);
                  }
                  $$renderer3.push(`<!--]-->`);
                } else {
                  $$renderer3.push("<!--[!-->");
                }
                $$renderer3.push(`<!--]-->`);
              } else {
                $$renderer3.push("<!--[!-->");
                if (og.type.toLowerCase() === "video.movie" || og.type.toLowerCase() === "video.episode" || og.type.toLowerCase() === "video.tv_show" || og.type.toLowerCase() === "video.other" && og.video) {
                  $$renderer3.push("<!--[-->");
                  if (og.video?.actors && og.video.actors.length) {
                    $$renderer3.push("<!--[-->");
                    $$renderer3.push(`<!--[-->`);
                    const each_array_5 = ensure_array_like(og.video.actors);
                    for (let $$index_5 = 0, $$length = each_array_5.length; $$index_5 < $$length; $$index_5++) {
                      let actor = each_array_5[$$index_5];
                      if (actor.profile) {
                        $$renderer3.push("<!--[-->");
                        $$renderer3.push(`<meta property="video:actor"${attr("content", actor.profile)}/>`);
                      } else {
                        $$renderer3.push("<!--[!-->");
                      }
                      $$renderer3.push(`<!--]--> `);
                      if (actor.role) {
                        $$renderer3.push("<!--[-->");
                        $$renderer3.push(`<meta property="video:actor:role"${attr("content", actor.role)}/>`);
                      } else {
                        $$renderer3.push("<!--[!-->");
                      }
                      $$renderer3.push(`<!--]-->`);
                    }
                    $$renderer3.push(`<!--]-->`);
                  } else {
                    $$renderer3.push("<!--[!-->");
                  }
                  $$renderer3.push(`<!--]--> `);
                  if (og.video?.directors && og.video.directors.length) {
                    $$renderer3.push("<!--[-->");
                    $$renderer3.push(`<!--[-->`);
                    const each_array_6 = ensure_array_like(og.video.directors);
                    for (let $$index_6 = 0, $$length = each_array_6.length; $$index_6 < $$length; $$index_6++) {
                      let director = each_array_6[$$index_6];
                      $$renderer3.push(`<meta property="video:director"${attr("content", director)}/>`);
                    }
                    $$renderer3.push(`<!--]-->`);
                  } else {
                    $$renderer3.push("<!--[!-->");
                  }
                  $$renderer3.push(`<!--]--> `);
                  if (og.video?.writers && og.video.writers.length) {
                    $$renderer3.push("<!--[-->");
                    $$renderer3.push(`<!--[-->`);
                    const each_array_7 = ensure_array_like(og.video.writers);
                    for (let $$index_7 = 0, $$length = each_array_7.length; $$index_7 < $$length; $$index_7++) {
                      let writer = each_array_7[$$index_7];
                      $$renderer3.push(`<meta property="video:writer"${attr("content", writer)}/>`);
                    }
                    $$renderer3.push(`<!--]-->`);
                  } else {
                    $$renderer3.push("<!--[!-->");
                  }
                  $$renderer3.push(`<!--]--> `);
                  if (og.video?.duration) {
                    $$renderer3.push("<!--[-->");
                    $$renderer3.push(`<meta property="video:duration"${attr("content", og.video.duration.toString())}/>`);
                  } else {
                    $$renderer3.push("<!--[!-->");
                  }
                  $$renderer3.push(`<!--]--> `);
                  if (og.video?.releaseDate) {
                    $$renderer3.push("<!--[-->");
                    $$renderer3.push(`<meta property="video:release_date"${attr("content", og.video.releaseDate)}/>`);
                  } else {
                    $$renderer3.push("<!--[!-->");
                  }
                  $$renderer3.push(`<!--]--> `);
                  if (og.video?.tags && og.video.tags.length) {
                    $$renderer3.push("<!--[-->");
                    $$renderer3.push(`<!--[-->`);
                    const each_array_8 = ensure_array_like(og.video.tags);
                    for (let $$index_8 = 0, $$length = each_array_8.length; $$index_8 < $$length; $$index_8++) {
                      let tag = each_array_8[$$index_8];
                      $$renderer3.push(`<meta property="video:tag"${attr("content", tag)}/>`);
                    }
                    $$renderer3.push(`<!--]-->`);
                  } else {
                    $$renderer3.push("<!--[!-->");
                  }
                  $$renderer3.push(`<!--]--> `);
                  if (og.video?.series) {
                    $$renderer3.push("<!--[-->");
                    $$renderer3.push(`<meta property="video:series"${attr("content", og.video.series)}/>`);
                  } else {
                    $$renderer3.push("<!--[!-->");
                  }
                  $$renderer3.push(`<!--]-->`);
                } else {
                  $$renderer3.push("<!--[!-->");
                }
                $$renderer3.push(`<!--]-->`);
              }
              $$renderer3.push(`<!--]-->`);
            }
            $$renderer3.push(`<!--]-->`);
          }
          $$renderer3.push(`<!--]-->`);
        } else {
          $$renderer3.push("<!--[!-->");
        }
        $$renderer3.push(`<!--]--> `);
        if (og.title) {
          $$renderer3.push("<!--[-->");
          $$renderer3.push(`<meta property="og:title"${attr("content", decorate(og.title))}/>`);
        } else {
          $$renderer3.push("<!--[!-->");
        }
        $$renderer3.push(`<!--]--> `);
        if (og.description || description) {
          $$renderer3.push("<!--[-->");
          $$renderer3.push(`<meta property="og:description"${attr("content", og.description || description)}/>`);
        } else {
          $$renderer3.push("<!--[!-->");
        }
        $$renderer3.push(`<!--]--> `);
        if (og.images && og.images.length) {
          $$renderer3.push("<!--[-->");
          $$renderer3.push(`<!--[-->`);
          const each_array_9 = ensure_array_like(og.images);
          for (let $$index_9 = 0, $$length = each_array_9.length; $$index_9 < $$length; $$index_9++) {
            let image = each_array_9[$$index_9];
            $$renderer3.push(`<meta property="og:image"${attr("content", image.url)}/> `);
            if (image.alt) {
              $$renderer3.push("<!--[-->");
              $$renderer3.push(`<meta property="og:image:alt"${attr("content", image.alt)}/>`);
            } else {
              $$renderer3.push("<!--[!-->");
            }
            $$renderer3.push(`<!--]--> `);
            if (image.width) {
              $$renderer3.push("<!--[-->");
              $$renderer3.push(`<meta property="og:image:width"${attr("content", image.width.toString())}/>`);
            } else {
              $$renderer3.push("<!--[!-->");
            }
            $$renderer3.push(`<!--]--> `);
            if (image.height) {
              $$renderer3.push("<!--[-->");
              $$renderer3.push(`<meta property="og:image:height"${attr("content", image.height.toString())}/>`);
            } else {
              $$renderer3.push("<!--[!-->");
            }
            $$renderer3.push(`<!--]--> `);
            if (image.secureUrl) {
              $$renderer3.push("<!--[-->");
              $$renderer3.push(`<meta property="og:image:secure_url"${attr("content", image.secureUrl.toString())}/>`);
            } else {
              $$renderer3.push("<!--[!-->");
            }
            $$renderer3.push(`<!--]--> `);
            if (image.type) {
              $$renderer3.push("<!--[-->");
              $$renderer3.push(`<meta property="og:image:type"${attr("content", image.type.toString())}/>`);
            } else {
              $$renderer3.push("<!--[!-->");
            }
            $$renderer3.push(`<!--]-->`);
          }
          $$renderer3.push(`<!--]-->`);
        } else {
          $$renderer3.push("<!--[!-->");
        }
        $$renderer3.push(`<!--]--> `);
        if (og.videos && og.videos.length) {
          $$renderer3.push("<!--[-->");
          $$renderer3.push(`<!--[-->`);
          const each_array_10 = ensure_array_like(og.videos);
          for (let $$index_10 = 0, $$length = each_array_10.length; $$index_10 < $$length; $$index_10++) {
            let video = each_array_10[$$index_10];
            $$renderer3.push(`<meta property="og:video"${attr("content", video.url)}/> `);
            if (video.width) {
              $$renderer3.push("<!--[-->");
              $$renderer3.push(`<meta property="og:video:width"${attr("content", video.width.toString())}/>`);
            } else {
              $$renderer3.push("<!--[!-->");
            }
            $$renderer3.push(`<!--]--> `);
            if (video.height) {
              $$renderer3.push("<!--[-->");
              $$renderer3.push(`<meta property="og:video:height"${attr("content", video.height.toString())}/>`);
            } else {
              $$renderer3.push("<!--[!-->");
            }
            $$renderer3.push(`<!--]--> `);
            if (video.secureUrl) {
              $$renderer3.push("<!--[-->");
              $$renderer3.push(`<meta property="og:video:secure_url"${attr("content", video.secureUrl.toString())}/>`);
            } else {
              $$renderer3.push("<!--[!-->");
            }
            $$renderer3.push(`<!--]--> `);
            if (video.type) {
              $$renderer3.push("<!--[-->");
              $$renderer3.push(`<meta property="og:video:type"${attr("content", video.type.toString())}/>`);
            } else {
              $$renderer3.push("<!--[!-->");
            }
            $$renderer3.push(`<!--]-->`);
          }
          $$renderer3.push(`<!--]-->`);
        } else {
          $$renderer3.push("<!--[!-->");
        }
        $$renderer3.push(`<!--]--> `);
        if (og.audio && og.audio.length) {
          $$renderer3.push("<!--[-->");
          $$renderer3.push(`<!--[-->`);
          const each_array_11 = ensure_array_like(og.audio);
          for (let $$index_11 = 0, $$length = each_array_11.length; $$index_11 < $$length; $$index_11++) {
            let audio = each_array_11[$$index_11];
            $$renderer3.push(`<meta property="og:audio"${attr("content", audio.url)}/> `);
            if (audio.secureUrl) {
              $$renderer3.push("<!--[-->");
              $$renderer3.push(`<meta property="og:audio:secure_url"${attr("content", audio.secureUrl.toString())}/>`);
            } else {
              $$renderer3.push("<!--[!-->");
            }
            $$renderer3.push(`<!--]--> `);
            if (audio.type) {
              $$renderer3.push("<!--[-->");
              $$renderer3.push(`<meta property="og:audio:type"${attr("content", audio.type.toString())}/>`);
            } else {
              $$renderer3.push("<!--[!-->");
            }
            $$renderer3.push(`<!--]-->`);
          }
          $$renderer3.push(`<!--]-->`);
        } else {
          $$renderer3.push("<!--[!-->");
        }
        $$renderer3.push(`<!--]--> `);
        if (og.locale) {
          $$renderer3.push("<!--[-->");
          $$renderer3.push(`<meta property="og:locale"${attr("content", og.locale)}/>`);
        } else {
          $$renderer3.push("<!--[!-->");
        }
        $$renderer3.push(`<!--]--> `);
        if (og.siteName) {
          $$renderer3.push("<!--[-->");
          $$renderer3.push(`<meta property="og:site_name"${attr("content", og.siteName)}/>`);
        } else {
          $$renderer3.push("<!--[!-->");
        }
        $$renderer3.push(`<!--]-->`);
      } else {
        $$renderer3.push("<!--[!-->");
      }
      $$renderer3.push(`<!--]--> `);
      if (languageAlternates && languageAlternates.length > 0) {
        $$renderer3.push("<!--[-->");
        $$renderer3.push(`<!--[-->`);
        const each_array_12 = ensure_array_like(languageAlternates);
        for (let $$index_12 = 0, $$length = each_array_12.length; $$index_12 < $$length; $$index_12++) {
          let languageAlternate = each_array_12[$$index_12];
          $$renderer3.push(`<link rel="alternate"${attr("hreflang", languageAlternate.hrefLang)}${attr("href", languageAlternate.href)}/>`);
        }
        $$renderer3.push(`<!--]-->`);
      } else {
        $$renderer3.push("<!--[!-->");
      }
      $$renderer3.push(`<!--]--> `);
      if (additionalLinkTags?.length) {
        $$renderer3.push("<!--[-->");
        $$renderer3.push(`<!--[-->`);
        const each_array_13 = ensure_array_like(additionalLinkTags);
        for (let $$index_13 = 0, $$length = each_array_13.length; $$index_13 < $$length; $$index_13++) {
          let tag = each_array_13[$$index_13];
          $$renderer3.push(`<link${attributes({ ...tag })} onload="this.__e=event" onerror="this.__e=event"/>`);
        }
        $$renderer3.push(`<!--]-->`);
      } else {
        $$renderer3.push("<!--[!-->");
      }
      $$renderer3.push(`<!--]--> `);
      if (additionalMetaTags && Array.isArray(additionalMetaTags)) {
        $$renderer3.push("<!--[-->");
        $$renderer3.push(`<!--[-->`);
        const each_array_14 = ensure_array_like(additionalMetaTags);
        for (let $$index_14 = 0, $$length = each_array_14.length; $$index_14 < $$length; $$index_14++) {
          let tag = each_array_14[$$index_14];
          $$renderer3.push(`<meta${attributes({ ...tag })}/>`);
        }
        $$renderer3.push(`<!--]-->`);
      } else {
        $$renderer3.push("<!--[!-->");
      }
      $$renderer3.push(`<!--]-->`);
    });
    bind_props($$props, {
      title,
      description,
      canonical,
      keywords,
      author,
      robots,
      lang,
      twitter,
      og,
      geo,
      additionalRobotsProps,
      languageAlternates,
      additionalMetaTags,
      additionalLinkTags
    });
  });
}
function Nav($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    var $$store_subs;
    const menu = [
      { name: "Home", path: "/", target: "_self" },
      {
        name: "Find Tutors",
        path: "https://worldotutor.com/find-tutor",
        target: "_blank"
      },
      {
        name: "Explore",
        path: "https://worldotutor.com/explore",
        target: "_blank"
      },
      { name: "Workshops", path: "/workshops", target: "_self" }
    ];
    let clazz = $$props["clazz"];
    $$renderer2.push(`<div${attr_class(`text-[16px] md:flex-row flex-col flex space-y-2 md:space-y-0 space-x-6 ${stringify(clazz)}`)}><!--[-->`);
    const each_array = ensure_array_like(menu);
    for (let $$index = 0, $$length = each_array.length; $$index < $$length; $$index++) {
      let item = each_array[$$index];
      $$renderer2.push(`<a${attr("href", item.path)}${attr_class(`relative px-1 transition-colors duration-200 hover:text-primary ${stringify(store_get($$store_subs ??= {}, "$page", page).url.pathname === item.path ? " text-primary" : "")} `)}${attr("target", item.target)}>${escape_html(item.name)} `);
      if (store_get($$store_subs ??= {}, "$page", page).url.pathname === item.path) {
        $$renderer2.push("<!--[-->");
        $$renderer2.push(`<span class="absolute left-0 bottom-0 w-full bg-primary rounded mt-0.5"></span>`);
      } else {
        $$renderer2.push("<!--[!-->");
      }
      $$renderer2.push(`<!--]--></a>`);
    }
    $$renderer2.push(`<!--]--></div>`);
    if ($$store_subs) unsubscribe_stores($$store_subs);
    bind_props($$props, { clazz });
  });
}
function Header($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    $$renderer2.push(`<header class="fixed h-20 flex items-center text-lg shadow w-full bg-(--background)/95 z-30"><nav class="flex justify-between items-center container mx-auto w-full"><div class="flex items-center"><a href="/"><img src="/Logo/logo.png" alt="connected care logo" class="max-w-44"/></a></div> <div class="hidden md:block">`);
    Nav($$renderer2, { clazz: "font-medium" });
    $$renderer2.push(`<!----></div> <div class="flex items-center gap-2"><div class="md:flex gap-4 hidden">`);
    Button($$renderer2, {
      class: "w-full capitalize px-6",
      size: "sm",
      disabled: false,
      href: "https://worldotutor.com/booktrail",
      target: "_blank",
      children: ($$renderer3) => {
        $$renderer3.push(`<!---->Book a free trail`);
      },
      $$slots: { default: true }
    });
    $$renderer2.push(`<!----></div></div> <div class="md:hidden flex items-center z-50"><button class="p-2 rounded focus:outline-none focus:ring-2 focus:ring-primary" aria-label="Open menu"><svg xmlns="http://www.w3.org/2000/svg" class="h-7 w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path></svg></button></div> `);
    {
      $$renderer2.push("<!--[!-->");
    }
    $$renderer2.push(`<!--]--></nav></header>`);
  });
}
const emailSchema = z.string().email("Invalid email address");
function linear(t) {
  return t;
}
const defaults = {
  duration: 4e3,
  initial: 1,
  next: 0,
  pausable: false,
  dismissable: true,
  reversed: false,
  intro: { x: 256 }
};
function createToast() {
  const { subscribe, update } = writable(new Array());
  const options = {};
  let count = 0;
  function _obj(obj) {
    return obj instanceof Object;
  }
  function _init(target = "default", opts = {}) {
    options[target] = opts;
    return options;
  }
  function push(msg, opts) {
    const param = {
      target: "default",
      ..._obj(msg) ? (
        /** @type {SvelteToastOptions} */
        msg
      ) : { ...opts, msg }
    };
    const conf = options[param.target] || {};
    const entry = {
      ...defaults,
      ...conf,
      ...param,
      theme: { ...conf.theme, ...param.theme },
      classes: [...conf.classes || [], ...param.classes || []],
      id: ++count
    };
    update((n) => entry.reversed ? [...n, entry] : [entry, ...n]);
    return count;
  }
  function pop(id) {
    update((n) => {
      if (!n.length || id === 0) return [];
      if (typeof id === "function") return n.filter((i) => id(i));
      if (_obj(id))
        return n.filter(
          /** @type {SvelteToastOptions[]} i */
          (i) => i.target !== id.target
        );
      const found = id || Math.max(...n.map((i) => i.id));
      return n.filter((i) => i.id !== found);
    });
  }
  function set(id, opts) {
    const param = _obj(id) ? id : { ...opts, id };
    update((n) => {
      const idx = n.findIndex((i) => i.id === param.id);
      if (idx > -1) {
        n[idx] = { ...n[idx], ...param };
      }
      return n;
    });
  }
  return { subscribe, push, pop, set, _init };
}
const toast = createToast();
function is_date(obj) {
  return Object.prototype.toString.call(obj) === "[object Date]";
}
function get_interpolator(a, b) {
  if (a === b || a !== a) return () => a;
  const type = typeof a;
  if (type !== typeof b || Array.isArray(a) !== Array.isArray(b)) {
    throw new Error("Cannot interpolate values of different type");
  }
  if (Array.isArray(a)) {
    const arr = (
      /** @type {Array<any>} */
      b.map((bi, i) => {
        return get_interpolator(
          /** @type {Array<any>} */
          a[i],
          bi
        );
      })
    );
    return (t) => arr.map((fn) => fn(t));
  }
  if (type === "object") {
    if (!a || !b) {
      throw new Error("Object cannot be null");
    }
    if (is_date(a) && is_date(b)) {
      const an = a.getTime();
      const bn = b.getTime();
      const delta = bn - an;
      return (t) => new Date(an + t * delta);
    }
    const keys = Object.keys(b);
    const interpolators = {};
    keys.forEach((key) => {
      interpolators[key] = get_interpolator(a[key], b[key]);
    });
    return (t) => {
      const result = {};
      keys.forEach((key) => {
        result[key] = interpolators[key](t);
      });
      return result;
    };
  }
  if (type === "number") {
    const delta = (
      /** @type {number} */
      b - /** @type {number} */
      a
    );
    return (t) => a + t * delta;
  }
  return () => b;
}
function tweened(value, defaults2 = {}) {
  const store = writable(value);
  let task;
  let target_value = value;
  function set(new_value, opts) {
    target_value = new_value;
    if (value == null) {
      store.set(value = new_value);
      return Promise.resolve();
    }
    let previous_task = task;
    let started = false;
    let {
      delay = 0,
      duration = 400,
      easing = linear,
      interpolate = get_interpolator
    } = { ...defaults2, ...opts };
    if (duration === 0) {
      if (previous_task) {
        previous_task.abort();
        previous_task = null;
      }
      store.set(value = target_value);
      return Promise.resolve();
    }
    const start = raf.now() + delay;
    let fn;
    task = loop((now2) => {
      if (now2 < start) return true;
      if (!started) {
        fn = interpolate(
          /** @type {any} */
          value,
          new_value
        );
        if (typeof duration === "function")
          duration = duration(
            /** @type {any} */
            value,
            new_value
          );
        started = true;
      }
      if (previous_task) {
        previous_task.abort();
        previous_task = null;
      }
      const elapsed = now2 - start;
      if (elapsed > /** @type {number} */
      duration) {
        store.set(value = new_value);
        return false;
      }
      store.set(value = fn(easing(elapsed / duration)));
      return true;
    });
    return task.promise;
  }
  return {
    set,
    update: (fn, opts) => set(fn(
      /** @type {any} */
      target_value,
      /** @type {any} */
      value
    ), opts),
    subscribe: store.subscribe
  };
}
function ToastItem($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    var $$store_subs;
    let item = $$props["item"];
    let next = item.initial;
    let cprops = {};
    let event;
    const progress = tweened(item.initial, { duration: item.duration, easing: linear });
    function close(ev) {
      toast.pop(item.id);
    }
    function autoclose() {
      if (store_get($$store_subs ??= {}, "$progress", progress) === 1 || store_get($$store_subs ??= {}, "$progress", progress) === 0) close();
    }
    function check(prop, kind = "undefined") {
      return typeof prop === kind;
    }
    onDestroy(() => {
      item.onpop && item.onpop(item.id, { event });
    });
    if (next !== item.next) {
      next = item.next;
      store_get($$store_subs ??= {}, "$progress", progress);
      progress.set(next).then(autoclose);
    }
    if (item.component) {
      const { props = {}, sendIdTo } = item.component;
      cprops = { ...props, ...sendIdTo && { [sendIdTo]: item.id } };
    }
    if (!check(item.progress)) {
      item.next = item.progress;
    }
    $$renderer2.push(`<div role="status"${attr_class("_toastItem svelte-1irx82o", void 0, { "pe": item.pausable })}><div${attr_class("_toastMsg svelte-1irx82o", void 0, { "pe": item.component })}>`);
    if (item.component) {
      $$renderer2.push("<!--[-->");
      $$renderer2.push(`<!---->`);
      item.component.src?.($$renderer2, spread_props([cprops]));
      $$renderer2.push(`<!---->`);
    } else {
      $$renderer2.push("<!--[!-->");
      $$renderer2.push(`${html(item.msg)}`);
    }
    $$renderer2.push(`<!--]--></div> `);
    if (item.dismissable) {
      $$renderer2.push("<!--[-->");
      $$renderer2.push(`<div class="_toastBtn pe svelte-1irx82o" role="button" tabindex="0"></div>`);
    } else {
      $$renderer2.push("<!--[!-->");
    }
    $$renderer2.push(`<!--]--> <progress class="_toastBar svelte-1irx82o"${attr("value", store_get($$store_subs ??= {}, "$progress", progress))}></progress></div>`);
    if ($$store_subs) unsubscribe_stores($$store_subs);
    bind_props($$props, { item });
  });
}
function SvelteToast($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    var $$store_subs;
    let options = fallback($$props["options"], () => ({}), true);
    let target = fallback($$props["target"], "default");
    let items = [];
    function getCss(theme) {
      return theme ? Object.keys(theme).reduce((a, c) => `${a}${c}:${theme[c]};`, "") : void 0;
    }
    toast._init(target, options);
    items = store_get($$store_subs ??= {}, "$toast", toast).filter((i) => i.target === target);
    $$renderer2.push(`<ul class="_toastContainer svelte-1dwp7pi"><!--[-->`);
    const each_array = ensure_array_like(items);
    for (let $$index = 0, $$length = each_array.length; $$index < $$length; $$index++) {
      let item = each_array[$$index];
      $$renderer2.push(`<li${attr_class(clsx(item.classes?.join(" ")), "svelte-1dwp7pi")}${attr_style(getCss(item.theme))}>`);
      ToastItem($$renderer2, { item });
      $$renderer2.push(`<!----></li>`);
    }
    $$renderer2.push(`<!--]--></ul>`);
    if ($$store_subs) unsubscribe_stores($$store_subs);
    bind_props($$props, { options, target });
  });
}
function TextInput($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    let label = fallback($$props["label"], "");
    let type = fallback($$props["type"], "text");
    let value = fallback($$props["value"], "");
    let placeholder = fallback($$props["placeholder"], "");
    let required = fallback($$props["required"], false);
    let disabled = fallback($$props["disabled"], false);
    let name = fallback($$props["name"], "");
    let schema = fallback(
      $$props["schema"],
      null
      // expects a Zod schema
    );
    let error = fallback($$props["error"], null);
    let className = fallback($$props["className"], "");
    let showSuccessFeedback = fallback(
      $$props["showSuccessFeedback"],
      true
      // Enable/disable green success feedback
    );
    let touched = false;
    let internalError = null;
    let isValid = false;
    let showSuccess = false;
    function validate(val = value) {
      if (schema) {
        const result = schema.safeParse(val);
        if (!result.success) {
          const isEmpty = !val || val.trim() === "";
          const isRequiredError = result.error.issues?.[0]?.message?.includes("required");
          if (isEmpty && !required && !isRequiredError) {
            internalError = null;
            isValid = false;
          } else {
            internalError = result.error.issues?.[0]?.message || "Invalid input";
            isValid = false;
          }
        } else {
          internalError = null;
          isValid = true;
        }
      } else {
        internalError = null;
        if (required && val.trim() === "") {
          isValid = false;
        } else if (val.trim() !== "") {
          isValid = true;
        } else {
          isValid = false;
        }
      }
      showSuccess = showSuccessFeedback && isValid && val.trim() !== "";
    }
    if (value !== void 0) {
      validate(value);
    }
    $$renderer2.push(`<div${attr_class(`flex flex-col gap-1 ${stringify(className)}`, "svelte-1li4pu5")}>`);
    if (label) {
      $$renderer2.push("<!--[-->");
      $$renderer2.push(`<label${attr("for", name)} class="font-medium text-gray-900 mb-0.5 flex items-center gap-2 svelte-1li4pu5">${escape_html(label)}${escape_html(required ? "*" : "")} `);
      if (showSuccess) {
        $$renderer2.push("<!--[-->");
        $$renderer2.push(`<span class="text-green-500 animate-fade-in svelte-1li4pu5"><svg class="w-4 h-4 svelte-1li4pu5" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" class="svelte-1li4pu5"></path></svg></span>`);
      } else {
        $$renderer2.push("<!--[!-->");
      }
      $$renderer2.push(`<!--]--></label>`);
    } else {
      $$renderer2.push("<!--[!-->");
    }
    $$renderer2.push(`<!--]--> <div class="relative svelte-1li4pu5"><input${attr("value", value)}${attr("type", type)}${attr("name", name)}${attr("id", name)}${attr_class(
      `rounded-md border text-sm px-3 py-2 pr-10 focus:outline-none placeholder:text-gray-200 transition w-full ${stringify(internalError && touched || error ? "border-red-500 focus:ring-red-500" : showSuccess ? "border-green-500 focus:ring-green-500 " : "border-gray-300 focus:ring-primary")} disabled:bg-gray-100 disabled:cursor-not-allowed`,
      "svelte-1li4pu5"
    )}${attr("placeholder", placeholder)}${attr("required", required, true)}${attr("disabled", disabled, true)} autocomplete="off"${attr("aria-invalid", !!(internalError && touched || error))}${attr("aria-describedby", name + "-error")}/> `);
    if (showSuccess) {
      $$renderer2.push("<!--[-->");
      $$renderer2.push(`<div class="absolute right-3 top-1/2 transform -translate-y-1/2 text-green-500 animate-bounce-in svelte-1li4pu5"><svg class="w-5 h-5 svelte-1li4pu5" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" class="svelte-1li4pu5"></path></svg></div>`);
    } else {
      $$renderer2.push("<!--[!-->");
    }
    $$renderer2.push(`<!--]--></div> `);
    if (internalError && touched || error) {
      $$renderer2.push("<!--[-->");
      $$renderer2.push(`<span class="text-sm text-red-600 mt-1 flex items-center gap-1 svelte-1li4pu5"${attr("id", name + "-error")}><svg class="w-4 h-4 svelte-1li4pu5" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd" class="svelte-1li4pu5"></path></svg> ${escape_html(internalError || error)}</span>`);
    } else {
      $$renderer2.push("<!--[!-->");
      if (showSuccess) {
        $$renderer2.push("<!--[-->");
        $$renderer2.push(`<span class="text-sm text-green-600 mt-1 flex items-center gap-1 animate-fade-in svelte-1li4pu5"><svg class="w-4 h-4 svelte-1li4pu5" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" class="svelte-1li4pu5"></path></svg> ${escape_html(value)}</span>`);
      } else {
        $$renderer2.push("<!--[!-->");
      }
      $$renderer2.push(`<!--]-->`);
    }
    $$renderer2.push(`<!--]--></div>`);
    bind_props($$props, {
      label,
      type,
      value,
      placeholder,
      required,
      disabled,
      name,
      schema,
      error,
      className,
      showSuccessFeedback
    });
  });
}
function Footer($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    const socials = [
      { icon: "mdi:instagram", label: "Instagram", href: "#" },
      { icon: "mdi:facebook", label: "Facebook", href: "#" }
    ];
    const resources = [
      {
        label: "Student & Parent Policy",
        href: "https://worldotutor.com/legal/student-parent-policy",
        target: "_blank"
      },
      {
        label: "Teacher Policy",
        href: "https://worldotutor.com/legal/teacher-policy",
        target: "_blank"
      },
      {
        label: "FAQs",
        href: "https://worldotutor.com/#faqs",
        target: "_blank"
      },
      {
        label: "Stay Safe",
        href: "https://worldotutor.com/stay-safe",
        target: "_blank"
      },
      {
        label: "Share a story",
        href: "https://worldotutor.com/share-story",
        target: "_blank"
      },
      {
        label: "Terms And Conditions",
        href: "https://worldotutor.com/legal/terms-conditions",
        target: "_blank"
      }
    ];
    const inputdata = { email: "" };
    let isSubmitting = false;
    let $$settled = true;
    let $$inner_renderer;
    function $$render_inner($$renderer3) {
      $$renderer3.push(`<footer class="bg-[#181F2A] pt-8 pb-0 text-white border-t border-[#232C39]"><div class="container mx-auto px-4 py-16"><div class="grid grid-cols-1 gap-y-8 md:grid-cols-4 md:gap-x-8"><div><img src="/Logo/logo.png" alt="World of Tutors logo" class="mb-3 max-w-44 h-auto rounded bg-white p-1"/> <p class="text-gray-300 text-[13px] max-w-[230px] mb-6">India's largest online platform where thousands of students and teachers across the globe participate in an effective educational exchange.</p> <div class="flex space-x-3 mt-1"><!--[-->`);
      const each_array = ensure_array_like(socials);
      for (let $$index = 0, $$length = each_array.length; $$index < $$length; $$index++) {
        let social = each_array[$$index];
        $$renderer3.push(`<a${attr("href", social.href)}${attr("aria-label", "Follow us on " + social.label)} class="w-8 h-8 bg-[#232C39] flex items-center justify-center rounded-full hover:bg-orange-500 transition-all" target="_blank" rel="noopener noreferrer">`);
        if (social.icon === "mdi:instagram") {
          $$renderer3.push("<!--[-->");
          $$renderer3.push(`<svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path fill="currentColor" d="M7.75 2A5.75 5.75 0 002 7.75v8.5A5.75 5.75 0 007.75 22h8.5A5.75 5.75 0 0022 16.25v-8.5A5.75 5.75 0 0016.25 2h-8.5zM12 7.907A4.093 4.093 0 1112 16.094a4.093 4.093 0 010-8.187zm5.313 1.219a.906.906 0 11-1.812 0 .906.906 0 011.812 0zM12 9.36a2.64 2.64 0 100 5.279 2.64 2.64 0 000-5.28z"></path></svg>`);
        } else {
          $$renderer3.push("<!--[!-->");
          if (social.icon === "mdi:facebook") {
            $$renderer3.push("<!--[-->");
            $$renderer3.push(`<svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 24 24" fill="currentColor"><path d="M22.675 0h-21.35C.597 0 0 .592 0 1.326v21.348C0 23.408.597 24 1.325 24h11.495v-9.294H9.692v-3.622h3.128V8.413c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.797.143v3.24l-1.919.001c-1.504 0-1.797.715-1.797 1.763v2.312h3.587l-.467 3.622h-3.12V24h6.116C23.404 24 24 23.408 24 22.674V1.326C24 .592 23.404 0 22.675 0"></path></svg>`);
          } else {
            $$renderer3.push("<!--[!-->");
          }
          $$renderer3.push(`<!--]-->`);
        }
        $$renderer3.push(`<!--]--></a>`);
      }
      $$renderer3.push(`<!--]--></div></div> <div><span class="font-semibold text-white mb-3 block tracking-wide">Quick Links</span> <ul class="space-y-2 text-sm"><div class="flex flex-col text-gray-300">`);
      Nav($$renderer3, { clazz: "!flex !flex-col !text-gray-300" });
      $$renderer3.push(`<!----></div></ul></div> <div><span class="font-semibold text-white mb-3 block tracking-wide">Resources</span> <ul class="text-gray-300 space-y-4 text-sm"><!--[-->`);
      const each_array_1 = ensure_array_like(resources);
      for (let $$index_1 = 0, $$length = each_array_1.length; $$index_1 < $$length; $$index_1++) {
        let resource = each_array_1[$$index_1];
        $$renderer3.push(`<li><a${attr("href", resource.href)} class="hover:underline"${attr("target", resource.target)}>${escape_html(resource.label)}</a></li>`);
      }
      $$renderer3.push(`<!--]--></ul></div> <div><span class="font-semibold text-white mb-3 block tracking-wide">Stay Updated</span> <p class="text-gray-300 text-sm mb-3 max-w-xs">Subscribe to get updates on new worldotutor and offers</p> <form class="flex flex-col gap-2" method="POST">`);
      TextInput($$renderer3, {
        type: "email",
        placeholder: "Enter your email",
        name: "email",
        schema: emailSchema,
        required: true,
        get value() {
          return inputdata.email;
        },
        set value($$value) {
          inputdata.email = $$value;
          $$settled = false;
        }
      });
      $$renderer3.push(`<!----> `);
      Button($$renderer3, {
        size: "sm",
        type: "submit",
        class: `bg-orange-500 hover:bg-orange-600 ${stringify("")} text-white text-[13px] font-medium rounded px-5 py-2 transition-all`,
        disabled: isSubmitting,
        children: ($$renderer4) => {
          {
            $$renderer4.push("<!--[!-->");
            $$renderer4.push(`Subscribe`);
          }
          $$renderer4.push(`<!--]-->`);
        },
        $$slots: { default: true }
      });
      $$renderer3.push(`<!----></form> <div class="flex items-start gap-2 mt-4"><svg class="w-4 h-4 flex-shrink-0 mt-0.5 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M3 5.5a1.5 1.5 0 011.5-1.5h15a1.5 1.5 0 011.5 1.5v13a1.5 1.5 0 01-1.5 1.5h-15A1.5 1.5 0 013 18.5v-13zm0 3l9 6.5L21 8.5"></path></svg> <span class="text-[13px] text-gray-300 break-all select-all">support@worldotutor.com</span></div> <div class="flex items-center gap-2 mt-2"><svg class="w-4 h-4 text-gray-300" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M22 16.92v3a2.07 2.07 0 01-2.26 2.08A20 20 0 012 4.1 2.07 2.07 0 014.06 2h3a2.07 2.07 0 012.09 1.72c.13.91.31 1.77.56 2.58a2.07 2.07 0 01-.47 2.11L7.19 9.24a16 16 0 006.56 6.56l1.84-1.84a2.07 2.07 0 012.11-.47c.81.25 1.67.43 2.58.56A2.07 2.07 0 0122 16.92z"></path></svg> <span class="text-[13px] text-gray-300 select-all">+91 78146 80875</span></div></div></div></div> <div class="flex items-center justify-center py-8 border-t !border-gray-100"><p class="text-sm">© 2025 World'O'Tutors. All Rights Reserved.</p></div></footer>`);
    }
    do {
      $$settled = true;
      $$inner_renderer = $$renderer2.copy();
      $$render_inner($$inner_renderer);
    } while (!$$settled);
    $$renderer2.subsume($$inner_renderer);
  });
}
function _layout($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    var $$store_subs;
    let { children } = $$props;
    head("12qhfyh", $$renderer2, ($$renderer3) => {
      $$renderer3.push(`<link rel="icon"${attr("href", favicon)}/>`);
    });
    SvelteToast($$renderer2, {});
    $$renderer2.push(`<!----> `);
    Seo($$renderer2, {
      title: store_get($$store_subs ??= {}, "$page", page).data.seoData?.title || "Worldotutor Workshop",
      canonical: store_get($$store_subs ??= {}, "$page", page).data.seoData?.canonical,
      description: store_get($$store_subs ??= {}, "$page", page).data.seoData?.description || "Worldotutor Workshop",
      keywords: store_get($$store_subs ??= {}, "$page", page).data.seoData?.keywords || "Worldotutor Workshop",
      author: store_get($$store_subs ??= {}, "$page", page).data.seoData?.author || "Worldotutor Workshop",
      robots: store_get($$store_subs ??= {}, "$page", page).data.seoData?.robots,
      lang: store_get($$store_subs ??= {}, "$page", page).data.seoData?.lang,
      twitter: store_get($$store_subs ??= {}, "$page", page).data.seoData?.twitter,
      og: store_get($$store_subs ??= {}, "$page", page).data.seoData?.og,
      geo: store_get($$store_subs ??= {}, "$page", page).data.seoData?.geo
    });
    $$renderer2.push(`<!----> `);
    {
      $$renderer2.push("<!--[!-->");
      Header($$renderer2);
      $$renderer2.push(`<!----> <div class="pt-20 !bg-white">`);
      children($$renderer2);
      $$renderer2.push(`<!----></div> `);
      Footer($$renderer2);
      $$renderer2.push(`<!---->`);
    }
    $$renderer2.push(`<!--]-->`);
    if ($$store_subs) unsubscribe_stores($$store_subs);
  });
}
export {
  _layout as default
};
